import { ComponentProps, FC, useCallback } from "react"
import { IContactCategory } from "src/domain/entities"
import { contactCategoryUpdateService } from "src/domain/services/contactCategory/contactCategoryUpdateService"
import { useAuth } from "src/hooks"
import { FormikOnSubmit } from "src/utils/types"
import { IContactCategoryUpdateFormFields, ContactCategoryUpdateDrawerFormView } from "."

type Props = Omit<
	ComponentProps<typeof ContactCategoryUpdateDrawerFormView>,
	"handleSubmit"
> & {
	onSuccess?: (contactCategory: IContactCategory) => void
}

export const ContactCategoryUpdateDrawerFormController: FC<Props> = ({
	contactCategory,
	onSuccess,
	...rest
}) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<IContactCategoryUpdateFormFields>>(
		async (values, { setErrors }) => {
			try {
				const updatedContactCategory = await contactCategoryUpdateService(
					{ id: contactCategory.id, update: values },
					token,
				)
				onSuccess && onSuccess(updatedContactCategory)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ name: message })
			}
		},
		[onSuccess, rest, token, contactCategory.id],
	)

	return (
		<ContactCategoryUpdateDrawerFormView
			contactCategory={contactCategory}
			handleSubmit={handleSubmit}
			{...rest}
		/>
	)
}
